/**
 * Util to detect PWA or not in iOS
 */
export const isIOSPWA = (): boolean =>
    !!(<any>window.navigator).standalone && (<any>window.navigator).standalone === true;

/**
 * Util to detect PWA or not in Android
 */
export const isAndroidPWA = () => window.matchMedia('(display-mode: standalone)').matches;

/**
 * Util to detect PWA or not.
 */
export const isPWA = (): boolean => isAndroidPWA() || isIOSPWA();
